import { apiClient } from './apiClient';
import { AuthPayload, User } from '../domain';

type LoginResponse = {
  access_token: string;
};

export async function registerUser(payload: AuthPayload): Promise<void> {
  await apiClient.post('/auth/register', {
    email: payload.email,
    password: payload.password,
    full_name: payload.fullName,
  });
}

export async function loginUser(payload: AuthPayload): Promise<LoginResponse> {
  const response = await apiClient.post<LoginResponse>('/auth/login', {
    email: payload.email,
    password: payload.password,
  });
  return response.data;
}

export async function fetchProfile(token: string): Promise<User> {
  const response = await apiClient.get<User>('/auth/me', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}
